import { useEffect, useState } from 'react';

import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Dialog } from 'primereact/dialog';

export const ListaDefeitosDialog = ({ xLabel = '', data = { dados: [] }, setXLabel }) => {
    const [labelData, setLabelData] = useState([]);
    const [totalPorTurma, setTotalPorTurma] = useState([]);
    const [visible, setVisible] = useState(false);

    const onHide = () => {
        setXLabel('');
        setVisible(false);
    }

    useEffect(() => {
        if(xLabel.length > 0) {
            setVisible(true);
            
            let _data = data.dados.filter((e) => {
                return e.defeito === xLabel;
            });

            let turmas = [];

            _data.forEach((item) => {
                if(turmas.indexOf(item.turma) === -1) {
                    turmas.push(item.turma);
                }
            });

            turmas = turmas.sort((a, b) => { return a - b });

            let _totalPorTurma = [];

            turmas.forEach((turma) => {
                let dataTurma = _data.filter((e) => { return e.turma === turma});
                let totalMetragem = 0
                dataTurma.forEach((item) => {
                    totalMetragem += parseFloat(item.metragem);
                });

                _totalPorTurma.push({ 'turma': turma, 'total': totalMetragem.toFixed(2) });
            });

            setLabelData(_data);
            setTotalPorTurma(_totalPorTurma);
        }
    }, [data, xLabel])

    return (
        <Dialog
            header='Lista de Defeitos'
            onHide={onHide}
            visible={visible}
        >
            <div className='p-d-flex p-flex-column'>
                <ul>
                    {totalPorTurma.map((turma) => (
                        <li>Turma {turma.turma}: {turma.total}</li>
                    ))}
                </ul>
            </div>            

            <DataTable
                responsiveLayout='scroll'
                size='small'
                value={labelData}
            >
                <Column header='Defeito' field='defeito' />
                <Column header='Colaborador' field='colaborador' sortable />
                <Column header='Turma' field='turma' sortable />
                <Column header='(m)' field='metragem' sortable />
                <Column header='Nº Rolo' field='rolo' sortable />
                <Column header='Tear' field='tear' sortable />
                <Column header='Grupo' field='grupo' sortable />
            </DataTable>
        </Dialog>
    )
}